import React from 'react';

/**
 * RouteMotif — an on-brand A→B route diagram used on the login benefit cards.
 * A dashed route line runs from a start dot to an end pin, with one small glyph
 * naming the use case. Everything is drawn with `currentColor`, so the card sets
 * the role color (green for rides, terracotta for packages).
 */

const GLYPHS = {
  // simple car outline
  driver: (
    <>
      <rect x="47" y="32" width="26" height="11" rx="3" />
      <path d="M51 32 l3.5 -5 h11 l3.5 5" />
      <circle cx="53" cy="45.5" r="2.6" />
      <circle cx="67" cy="45.5" r="2.6" />
    </>
  ),
  // simple person outline
  passenger: (
    <>
      <circle cx="60" cy="30" r="4.5" />
      <path d="M51 46 c0 -6.5 4.5 -10 9 -10 s9 3.5 9 10" />
    </>
  ),
  // simple parcel outline
  package: (
    <>
      <rect x="49" y="30" width="22" height="16" rx="2" />
      <path d="M60 30 v16 M49 38 h22" />
    </>
  ),
};

const RouteMotif = ({ variant = 'driver', className = '' }) => (
  <svg
    className={`route-motif ${className}`.trim()}
    viewBox="0 0 120 72"
    role="img"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* route line */}
    <path
      d="M16 55 C 44 55, 46 22, 102 19"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeDasharray="1 7"
      opacity="0.75"
    />
    {/* start dot */}
    <circle cx="16" cy="55" r="4" fill="currentColor" />
    {/* end pin */}
    <path
      d="M102 6 a9 9 0 0 1 9 9 c0 7.5 -9 16 -9 16 s-9 -8.5 -9 -16 a9 9 0 0 1 9 -9 z"
      fill="currentColor"
    />
    <circle cx="102" cy="15" r="3.1" fill="#ffffff" opacity="0.9" />
    {/* role glyph */}
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeLinecap="round"
    >
      {GLYPHS[variant] || GLYPHS.driver}
    </g>
  </svg>
);

export default RouteMotif;
